var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNews(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_553",
    "data-name": "Group 553",
    transform: "translate(-1540 -740)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18",
    "data-name": "Rectangle 18",
    width: 64,
    height: 64,
    transform: "translate(1540 740)",
    fill: "rgba(255,255,255,0)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_525",
    "data-name": "Group 525",
    transform: "translate(-437.285 112.924)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2501",
    "data-name": "Path 2501",
    d: "M1995.352,686.5l.015.008,26.544-15.313a4.415,4.415,0,0,0,2-3.465l.014-28.951-6.011-4.631a7.462,7.462,0,0,1,1.376,3.108v6.789l-2.536-1.463v-5.057a4.047,4.047,0,0,0-6.139-3.417l-13.776,7.956a4.527,4.527,0,0,0-2.067,3.571l-.011,39.537a1.494,1.494,0,0,0,.591,1.328Z",
    transform: "translate(0.759 0.801)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2502",
    "data-name": "Path 2502",
    d: "M2012.924,634.074a4.43,4.43,0,0,0-2.007.525l-13.765,7.945a4.151,4.151,0,0,0-1.85,3.219l-.011,39.522c.047.434.058.613.238.814l26.283-15.157a4.022,4.022,0,0,0,1.794-3.1l.012-28.742-4.216-3.241a7.507,7.507,0,0,1,.418,1.434v6.865a.416.416,0,0,1-.2.367.442.442,0,0,1-.433,0l-2.532-1.463a.432.432,0,0,1-.216-.367v-5.057a3.673,3.673,0,0,0-1.717-3.039,3.311,3.311,0,0,0-1.794-.525Zm-17.442,52.968a.375.375,0,0,1-.217-.058c-.023-.01-.045-.029-.07-.043a1.928,1.928,0,0,1-.742-1.617l.014-39.577a4.922,4.922,0,0,1,2.259-3.931l13.786-7.963a4.589,4.589,0,0,1,4.66.029,4.506,4.506,0,0,1,2.114,3.766v4.8l1.7.972v-6.054a7.044,7.044,0,0,0-1.3-2.852.431.431,0,0,1,.051-.554.409.409,0,0,1,.547-.037l6.021,4.632a.416.416,0,0,1,.17.334l-.011,28.951a4.827,4.827,0,0,1-2.225,3.831l-26.546,15.31a.355.355,0,0,1-.212.061Z",
    transform: "translate(0.644 0.687)",
    fill: "#4f90ed",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2503",
    "data-name": "Path 2503",
    d: "M2013.454,644.325l3.7-2.139c1.825-.994,2.832-1.874.991-3.307l-7.816-6.092,3.123,4.749Z",
    transform: "translate(6.592 0.519)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2504",
    "data-name": "Path 2504",
    d: "M2012.2,634.811l1.721,2.608a.428.428,0,0,1,.073.234l-.011,6.054,3.068-1.768c.8-.44,1.721-1,1.758-1.5.036-.371-.422-.807-.815-1.109l-5.794-4.516Zm1.365,10.054a.512.512,0,0,1-.22-.056.416.416,0,0,1-.2-.367v-6.664l-3.057-4.645a.427.427,0,0,1,.624-.565l7.81,6.094c.811.634,1.185,1.234,1.134,1.843-.073.849-.917,1.479-2.186,2.168l-3.691,2.136a.489.489,0,0,1-.21.056Z",
    transform: "translate(6.477 0.403)",
    fill: "#649eef",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2505",
    "data-name": "Path 2505",
    d: "M1996.011,687.193l-2.367-1.365a1.507,1.507,0,0,1-.608-1.338l.011-39.534a4.565,4.565,0,0,1,2.067-3.573l14.564-8.406c2.161-1.215,3.346-1.825,5.892-.609a7.974,7.974,0,0,1,4.361,5.571v6.789l-2.536-1.463V638.21a4.047,4.047,0,0,0-6.139-3.417l-13.776,7.956a4.527,4.527,0,0,0-2.067,3.571l-.011,39.537a1.486,1.486,0,0,0,.609,1.336Z",
    transform: "translate(0.114 0.115)",
    fill: "#c8e6fe",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2506",
    "data-name": "Path 2506",
    d: "M2013.246,632.244A6.787,6.787,0,0,0,2010,633.46l-14.56,8.406a4.118,4.118,0,0,0-1.856,3.222l-.011,39.518c.048.566.058.693.444,1.01l1.1.627a1.531,1.531,0,0,1-.025-.231l.014-39.577a4.922,4.922,0,0,1,2.259-3.931l13.786-7.963a4.589,4.589,0,0,1,4.66.029,4.506,4.506,0,0,1,2.114,3.766v4.8l1.7.972v-6.054a7.6,7.6,0,0,0-4.134-5.189,5.156,5.156,0,0,0-2.245-.623Zm-17.12,55.485a.374.374,0,0,1-.217-.058l-2.364-1.361a1.963,1.963,0,0,1-.811-1.665l.011-39.574a4.955,4.955,0,0,1,2.259-3.929l14.575-8.417c2.1-1.182,3.489-1.96,6.284-.624a8.312,8.312,0,0,1,4.6,5.878v6.865a.416.416,0,0,1-.2.367.441.441,0,0,1-.433,0l-2.532-1.463a.432.432,0,0,1-.216-.367v-5.057a3.617,3.617,0,0,0-5.517-3.039L1997.8,643.23a4.11,4.11,0,0,0-1.85,3.219l-.011,39.522c.058.565.072.691.454,1.007a.433.433,0,0,1,.083.565.422.422,0,0,1-.351.186Z",
    fill: "#4f90ed",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2507",
    "data-name": "Path 2507",
    d: "M1998.19,662.6a.407.407,0,0,1-.359-.212.419.419,0,0,1,.158-.577l20.023-11.564a.423.423,0,0,1,.418.735l-20.024,11.56a.386.386,0,0,1-.216.058Z",
    transform: "translate(1.889 7.039)",
    fill: "#4f90ed",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2508",
    "data-name": "Path 2508",
    d: "M1999.809,667.249a.425.425,0,0,1-.216-.793l15.606-9a.422.422,0,1,1,.416.735l-15.593,9a.418.418,0,0,1-.213.058Z",
    transform: "translate(2.492 9.737)",
    fill: "#4f90ed",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2509",
    "data-name": "Path 2509",
    d: "M1998.19,665.642a.409.409,0,0,1-.359-.21.421.421,0,0,1,.158-.579l20.023-11.56a.423.423,0,0,1,.418.735l-20.024,11.56a.419.419,0,0,1-.216.054Z",
    transform: "translate(1.889 8.179)",
    fill: "#4f90ed",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2510",
    "data-name": "Path 2510",
    d: "M2008.132,645.526h0a5.9,5.9,0,0,0,.861-2.892,1.785,1.785,0,0,0-2.928-1.692,5.95,5.95,0,0,0-2.077,2.188,6.045,6.045,0,0,0-.862,2.892,2.074,2.074,0,0,0,.862,1.9C2005.137,648.583,2006.987,647.51,2008.132,645.526Z",
    transform: "translate(3.893 3.424)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2511",
    "data-name": "Path 2511",
    d: "M2007.483,641.079a2.288,2.288,0,0,0-1.1.345,6.122,6.122,0,0,0-2.723,4.715,1.682,1.682,0,0,0,.655,1.534c.919.533,2.558-.494,3.574-2.245h0a5.593,5.593,0,0,0,.8-2.678,1.67,1.67,0,0,0-.645-1.531,1.148,1.148,0,0,0-.562-.14Zm-2.619,7.577a1.941,1.941,0,0,1-.98-.252,2.452,2.452,0,0,1-1.061-2.265,6.841,6.841,0,0,1,3.142-5.449,2.206,2.206,0,0,1,3.574,2.061,6.45,6.45,0,0,1-.922,3.1h0C2007.616,647.595,2006.122,648.656,2004.864,648.656Z",
    transform: "translate(3.779 3.307)",
    fill: "#4f90ed",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2512",
    "data-name": "Path 2512",
    d: "M2010.588,645.987c-2.124-1.225-5.563.764-7.691,4.436a11.535,11.535,0,0,0-1.578,4.921l10.847-6.26a3.631,3.631,0,0,0-1.578-3.1Z",
    transform: "translate(3.216 5.329)",
    fill: "#7bbdfd",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2513",
    "data-name": "Path 2513",
    d: "M2009.306,646.17c-1.876,0-4.324,1.814-5.925,4.581a11.572,11.572,0,0,0-1.432,3.924l9.892-5.707a3.115,3.115,0,0,0-1.35-2.5h0a2.371,2.371,0,0,0-1.185-.3Zm-7.872,9.713a.392.392,0,0,1-.216-.06.433.433,0,0,1-.2-.386,11.874,11.874,0,0,1,1.64-5.107c2.268-3.937,5.9-5.956,8.254-4.591a4.022,4.022,0,0,1,1.792,3.435.422.422,0,0,1-.2.392l-10.847,6.26a.443.443,0,0,1-.224.056Z",
    transform: "translate(3.102 5.211)",
    fill: "#4f90ed",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNews);
export default __webpack_public_path__ + "static/media/news.98bc2ced19b56749279cb8df9d7436a0.svg";
export { ForwardRef as ReactComponent };